import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useRecoilValue, useResetRecoilState } from 'recoil';

import { MessageDialogInput, MessageDialogState } from '@atom/DialogState';

/*
  * 呼び出し方法
  onClick={() => {
    setMessageDialogState({
      open: true,
      messageData: {
        title: '登録してよいですか？',
        message: 'テスト用のダイアログです。'
      },
      onOkClick: () => {
        alert('onOkClick');
      },
      onCancelClick: () => {
        alert('onCancelClick');
      }
    })
  }}
 */
const MessageDialog = () => {
  const messageDialogState: MessageDialogInput = useRecoilValue(MessageDialogState);
  const resetMessageDialogState = useResetRecoilState(MessageDialogState);

  const { messageData, onOkClick, onCancelClick } = messageDialogState;

  const handleClose = () => {
    resetMessageDialogState();
  };

  return (
    <Dialog
      open={messageDialogState.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{messageData.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{messageData.message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {onCancelClick && (
          <Button
            onClick={() => {
              onCancelClick();
              handleClose();
            }}
          >
            Cancel
          </Button>
        )}
        {onOkClick ? (
          <Button
            autoFocus
            onClick={() => {
              onOkClick();
              handleClose();
            }}
          >
            OK
          </Button>
        ) : (
          <Button
            autoFocus
            onClick={() => {
              handleClose();
            }}
          >
            Close
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default MessageDialog;
